import { render, staticRenderFns } from "./Tjck.vue?vue&type=template&id=4a77698e&scoped=true&"
import script from "./Tjck.vue?vue&type=script&lang=js&"
export * from "./Tjck.vue?vue&type=script&lang=js&"
import style0 from "./Tjck.vue?vue&type=style&index=0&id=4a77698e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a77698e",
  null
  
)

export default component.exports